import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { Digit } from '../../api/models';

export type TABLE_TYPE = Table<Digit>;

export const TABLE = 'digit';
const SCHEMA = 'digitId, sortId';

class DigitDatabase implements DataRepository<Digit> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<Digit | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: Digit, key: Key): Promise<Digit> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: Digit[]): Promise<Digit[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<Digit[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const DigitDB = new DigitDatabase(db);
